import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import AuthorizedDeviceEnrollmentPage, { getDefaultPageData } from "components/pages/AuthorizedDeviceEnrollmentPage";
import Classes from "model";

export default function CaptureMabiFaceIDNickname(props) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);

    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
        .update([ "mobile", "name" ], "George's IPhone")
        .submit();

    return <AuthorizedDeviceEnrollmentPage data={ data } />
}